export default {
  meta: {
    title: '工具集'
  }
};
